import { component } from "picoapp";
import {
  PAGINATION_ACTIVE_CLASS,
  PAGINATION_INACTIVE_CLASS,
  PRODUCT_GALLERY_SETTINGS,
} from "../../sections/Carousels/tbsp-carousel--constants";

const isHidden = (node: HTMLElement) => {
  const styles = window.getComputedStyle(node);
  return styles.display === "none" || styles.visibility === "hidden";
};

const initCarousel = async (node: HTMLElement) => {
  const [{ default: Splide }] = await Promise.all([
    import("@splidejs/splide"),
    import("@splidejs/splide/css/core"),
  ]);

  const splide = new Splide(node, {
    ...PRODUCT_GALLERY_SETTINGS,
  });

  const slides = node.querySelectorAll(".splide__slide");

  splide.on("ready", () =>
    slides.forEach((slide) => slide.classList.remove("absolute", "invisible"))
  );

  splide.on("pagination:updated", (_, prev, curr) => {
    if (prev?.button) {
      prev.button.classList.add(PAGINATION_INACTIVE_CLASS);
      prev.button.classList.remove(PAGINATION_ACTIVE_CLASS);
    }

    if (curr?.button) {
      curr.button.classList.add(PAGINATION_ACTIVE_CLASS);
      curr.button.classList.remove(PAGINATION_INACTIVE_CLASS);
    }
  });

  splide.on("active", ({ slide }) => {
    const video = slide.querySelector("video");

    if (video) {
      video.play().catch((e) => console.log("video error", e));
    }
  });

  splide.on("inactive", ({ slide }) => {
    const video = slide.querySelector("video");

    if (video) {
      video.pause();
    }
  });

  splide.mount();
};

export const productGalleryCarousel = component((node: HTMLElement) => {
  const parent = node.parentElement;

  if (parent && isHidden(parent)) {
    const ro = new ResizeObserver((entries) => {
      for (const entry of entries) {
        if (entry.target === node && parent && !isHidden(parent)) {
          initCarousel(node);
          ro.disconnect();
        }
      }
    });

    // Observe one or multiple elements
    ro.observe(node);

    return;
  }

  initCarousel(node);
});
